import React, { useContext } from 'react';
import { useFormikContext } from 'formik';
import { observer } from 'mobx-react';
import {
  rentersPolicyAvailable,
  editableHouseholdMembersStates,
  driverCarAssignmentStates,
  editableResidenceInsuranceType,
  isResidentialOwnerStates
} from '@ourbranch/lookups';
import { policyTypes } from '@ourbranch/policy-types';

import { useStore } from 'core/store';
import { AuthContext } from 'core/components/auth';
import FormList from 'core/components/form-list';
import { useDisabledState } from 'common/disabled-context';
import CarAssignment from 'common/components/auto/car-assignment';
import { AddLienHoldersForm, LienHolders } from 'common/components/people';

import { Coverage } from './auto-coverage';
import Cars from './cars';
import Trailers from './trailers';
import Renters from './renters';
import PriorCoverage from './prior-coverage';
import AutoPolicyDetails from './auto-policy-details';
import { ResidenceInsuranceType } from './residence-insurance-type';

function AutoOffer() {
  const { values } = useFormikContext();
  const { offer } = useStore();
  const { viewOnly } = useContext(AuthContext);
  const { disabled } = useDisabledState();
  const { state, selectedOption } = offer;

  const showAutoPolicyDetails = editableHouseholdMembersStates.includes(state);

  // When looking at home options, can only add Renters when HA is selected
  // When looking at renters options, the renters details will appear in a new Tab at top of offer
  // so that's why we're not including that as part of the rendering logic here in Auto Details
  const showRenters =
    rentersPolicyAvailable[state] && selectedOption === policyTypes.HABundle && values.offerings.offerRenters;

  const showResidenceInsuranceTypeSelector =
    selectedOption === policyTypes.Auto &&
    (editableResidenceInsuranceType.includes(state) || isResidentialOwnerStates.includes(state));

  return (
    <>
      <Cars disabled={disabled} />
      {driverCarAssignmentStates[state] && <CarAssignment state={state} />}
      <Trailers disabled={disabled} offer={offer} />
      {showResidenceInsuranceTypeSelector && <ResidenceInsuranceType disabled={disabled} />}
      <Coverage disabled={disabled} offer={offer} />
      {showAutoPolicyDetails && <AutoPolicyDetails disabled={disabled} />}
      <PriorCoverage />
      {showRenters && <Renters disabled={disabled} />}
      <FormList
        key={`lien-holders-${disabled}`}
        id="lienHolders"
        item={LienHolders}
        addForm={AddLienHoldersForm}
        title="Interested Party or Lienholder"
        addLabel="Add Lien Holder"
        disabled={disabled || viewOnly}
        singular="Entity"
        plural="Entities"
      />
    </>
  );
}

export default observer(AutoOffer);
